import { AUTHENTICATION_FETCH_SUCCESS } from "./actions/authenticationActions";

export function authenticationStatus(state = { emailAddress: null }, action) {
    switch (action.type) {
        case AUTHENTICATION_FETCH_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/authentication/authenticationReducers.js
 **/